import React from 'react';
import { Button } from 'src/ui/Button';
import { Dropdown, MenuItem } from 'src/ui/Dropdown';
import { Input } from 'src/ui/Input';
import { useSelector } from 'react-redux';
import { selectConstant } from 'src/store/constantsSlice';

export interface ProfileFieldSelectorProps {
  value: string;
  onChange: (value: string) => void;
  answersPrefix?: string;
  supportRange?: boolean;
}

const ProfileFieldSelector = ({
  value,
  onChange,
  answersPrefix,
  supportRange,
}: ProfileFieldSelectorProps) => {
  const profileFields = [
    ...(useSelector(selectConstant('profileFields')) || []),
  ] as string[];
  if (supportRange) {
    for (let i = 0; i < profileFields.length; i++) {
      if (profileFields[i].endsWith('Max')) {
        profileFields.splice(
          i,
          0,
          profileFields[i].substring(0, profileFields[i].length - 3)
        );
        i++;
      }
    }
  }
  const [selectedField, secondaryName] = value.split('.');
  let prefix = '';
  let fieldValue = secondaryName || '';
  if (selectedField === 'answers' && answersPrefix) {
    prefix = `${answersPrefix}__`;
    if (fieldValue.startsWith(prefix)) {
      fieldValue = fieldValue.replace(prefix, '');
    }
  }
  return (
    <div className="col" style={{ gap: 8 }}>
      <Dropdown
        trigger={
          <Button variant="secondary" rightIcon="chevron-down">
            {selectedField}
          </Button>
        }
        width={220}
      >
        <div style={{ maxHeight: 320, overflowY: 'auto' }}>
          {profileFields?.map((field: string) => (
            <MenuItem key={field} onClick={() => onChange(field)}>
              {field}
            </MenuItem>
          ))}
        </div>
      </Dropdown>
      {selectedField === 'answers' && (
        <div className="row" style={{ gap: 8, alignItems: 'center' }}>
          <span
            style={{
              flexShrink: 0,
              fontSize: 'var(--fs-sm)',
              color: 'var(--text-muted)',
            }}
          >
            {`${prefix}`}
          </span>
          <Input
            style={{ maxWidth: 150 }}
            value={fieldValue}
            onChange={(e) => onChange(`answers.${prefix}${e.target.value}`)}
            placeholder="gender_other"
          />
        </div>
      )}
    </div>
  );
};

export default ProfileFieldSelector;
